// =============================================================================
// normalizeList — collapse the backend's four different list-response envelopes
// into one predictable shape: { rows, total, page, totalPages }.
//
// Envelopes in the wild (see backend audit):
//   1. Orders:               { data, total, page, totalPages }
//   2. Products/Customers:    { data, pagination: { next, prev } }   (no total)
//   3. Suppliers:             { suppliers, total, page, totalPages }
//   4. Refunds/Cats/Brands/…: { data, count }                        (no paging)
// =============================================================================

export function normalizeList(response, { page = 1, pageSize = 20 } = {}) {
  if (!response) {
    return { rows: [], total: 0, page, totalPages: 1 };
  }

  // Locate the array payload regardless of key.
  const rows =
    response.data ??
    response.suppliers ??
    response.orders ??
    response.results ??
    (Array.isArray(response) ? response : []);

  // Total: prefer explicit total, else count, else fall back to page length.
  const total =
    response.total ??
    response.count ??
    (Array.isArray(rows) ? rows.length : 0);

  const currentPage = response.page ?? page;

  const totalPages =
    response.totalPages ??
    (total && pageSize ? Math.max(1, Math.ceil(total / pageSize)) : 1);

  return {
    rows: Array.isArray(rows) ? rows : [],
    total,
    page: currentPage,
    totalPages,
  };
}
